module.exports = __webpack_public_path__ + "img/the rabbits reunion.566fabbf.png";